module.exports = __webpack_public_path__ + "card-MC.png?e73a672a073bb7664509c8049c09982f";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/card-MC.png
// module id = 200
// module chunks = 0